import React, { useMemo } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import NavbarLayout from "./components/NavbarSidebar/NavbarLayout";
import LoginView from "./components/Login/LoginView";
import SignalRegisterView from "./components/Login/SignalRegisterView";
import SignalProvider from "./components/SignalProvider/SignalProvider";
import NavbarAndSidebarSignal from "./components/NavbarSidebar/NavbarAndSidebarSignal.js";
import NavbarAndSidebarFollower from "./components/NavbarSidebar/NavbarAndSidebarFollower.js";
import Follower from "./components/Follower/Follower";
import NotFound from "./components/404/notFound";
import CookieChecker from "./Tools/CookieChecker";
import { useMediaQuery, useTheme } from "@mui/material";
import { BreakpointProvider } from "./config/BreakpointContext.js";
import ShareIntermediary from "./Master Data/shareIntermediary";
import NavbarAndSidebarAdmin from "./components/NavbarSidebar/NavbarAndSidebarAdmin";
import AccountsScreen from "./components/Administrator/Accounts/AccountsScreen";

export const baseEnv = ``;
export const env = ``; 
export const server = ``;

function App(props) {
  const theme = useTheme();
  const issXs = useMediaQuery(theme.breakpoints.between("xs", "md"));
  const isXs = useMediaQuery(theme.breakpoints.between("xs", "lg"));
  const isMd = useMediaQuery(theme.breakpoints.up("lg"));

  const breakpointValue = useMemo(
    () => ({
      isXs,
      isMd,
      issXs
    }),
    [isXs, isMd, issXs]
  );

  return (
    <BreakpointProvider value={breakpointValue}>
      <BrowserRouter>
        <Routes>
          <Route
            path={"/login"}
            element={
              <NavbarLayout>
                <LoginView type = "user"/>
              </NavbarLayout>
            }
          />
          <Route
            path={"/admin/login"}
            element={
              <NavbarLayout>
                <LoginView type = "admin"/>
              </NavbarLayout>
            }
          />
          <Route
            path={"/login/:idStrategy"}
            element={
              <NavbarLayout>
                <LoginView />
              </NavbarLayout>
            }
          />
          <Route
            path={"/signal-register"}
            element={
              <NavbarLayout>
                <SignalRegisterView />
              </NavbarLayout>
            }
          />
          <Route
            path={"*"}
            element={
              <CookieChecker>
                <Routes>
                  <Route
                    path={"/"}
                    element={
                      <NavbarLayout>
                        <LoginView />
                      </NavbarLayout>
                    }
                  />
                  <Route
                    path={"/signal-provider/profile"}
                    element={
                      <NavbarAndSidebarSignal sidebarOption="SignalProfile">
                        <SignalProvider page="profile">Signal</SignalProvider>
                      </NavbarAndSidebarSignal>
                    }
                  />
                  <Route
                    path={"/signal-provider/followers"}
                    element={
                      <NavbarAndSidebarSignal sidebarOption="Followers">
                        <SignalProvider page="followers">
                          Follower
                        </SignalProvider>
                      </NavbarAndSidebarSignal>
                    }
                  />
                  <Route
                    path={"/signal-provider/orders"}
                    element={
                      <NavbarAndSidebarSignal sidebarOption="SignalOrders">
                        <SignalProvider page="orders">Orders</SignalProvider>
                      </NavbarAndSidebarSignal>
                    }
                  />
                  <Route
                    path={"/signal-provider/strategy-settings"}
                    element={
                      <NavbarAndSidebarSignal sidebarOption="SignalProfile">
                        <SignalProvider page="updateStrategy">
                          Create strategy
                        </SignalProvider>
                      </NavbarAndSidebarSignal>
                    }
                  />
                  <Route
                    path={"/follower/following-settings"}
                    element={
                      <NavbarAndSidebarFollower sidebarOption="FollowingSettings">
                        <Follower page="followingSettings">
                          Following settings
                        </Follower>
                      </NavbarAndSidebarFollower>
                    }
                  />
                  <Route
                    path={"/follower/discover"}
                    element={
                      <NavbarAndSidebarFollower sidebarOption="Discover">
                        <Follower page={"discover"}>Discover</Follower>
                      </NavbarAndSidebarFollower>
                    }
                  />
                  <Route
                    path={"/follower/discover/strategy/:idStrategy"}
                    element={
                      <NavbarAndSidebarFollower sidebarOption="Discover">
                        <Follower page={"discoverMore"}>Discover</Follower>
                      </NavbarAndSidebarFollower>
                    }
                  />
                  <Route
                    path={"/follower/orders"}
                    element={
                      <NavbarAndSidebarFollower sidebarOption="Orders">
                        <Follower page={"orders"}>Orders</Follower>
                      </NavbarAndSidebarFollower>
                    }
                  />
                  <Route
                    path={"/shared_signal_link/:id"}
                    element={
                      <ShareIntermediary/>
                    }
                  />
                  <Route
                    path={"/admin/dashboard"}
                    element={
                      <NavbarAndSidebarAdmin sidebarOption="Dashboard">
                        {/* Component Admin or redirection */}
                      </NavbarAndSidebarAdmin>
                    }
                  />
                  <Route
                    path={"/admin/accounts"}
                    element={
                      <NavbarAndSidebarAdmin sidebarOption="Accounts">
                        <AccountsScreen />
                      </NavbarAndSidebarAdmin>
                    }
                  />
                  <Route
                    path={"/admin/trading"}
                    element={
                      <NavbarAndSidebarAdmin sidebarOption="Copies">
                        {/* Component Admin or redirection */}
                      </NavbarAndSidebarAdmin>
                    }
                  />
                  <Route
                    path={"/admin/supports"}
                    element={
                      <NavbarAndSidebarAdmin sidebarOption="Supports">
                        {/* Component Admin or redirection */}
                      </NavbarAndSidebarAdmin>
                    }
                  />
                  <Route
                    path={"/admin/statements"}
                    element={
                      <NavbarAndSidebarAdmin sidebarOption="Statements">
                        {/* Component Admin or redirection */}
                      </NavbarAndSidebarAdmin>
                    }
                  />
                  <Route
                    path={"/admin/logs"}
                    element={
                      <NavbarAndSidebarAdmin sidebarOption="Logs History">
                        {/* Component Admin or redirection */}
                      </NavbarAndSidebarAdmin>
                    }
                  />
                  <Route exact path="*" element={<NotFound />} />
                </Routes>
              </CookieChecker>
            }
          />
          <Route exact path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </BreakpointProvider>
  );
}

export default App;
